import {
	UPDATE_POST, 
	UPDATE_POST_TITLE, 
	UPDATE_POST_SLUG, 
	UPDATE_POST_CONTENT, 
	UPDATE_POST_EXCERPT,
	UPDATE_POST_TAGS, 
	UPDATE_POST_CATEGORIES,
	ADD_POST_CATEGORY,
	DELETE_POST_CATEGORY,
	CLEAR_POST
} from 'constants';
export const post = (state = {}, action) => {
	switch(action.type) {
		case UPDATE_POST:
			return Object.assign({},state, action.post);
		case UPDATE_POST_TITLE:
			return Object.assign({},state, {
				title : action.value
			});
		case UPDATE_POST_SLUG:
			return Object.assign({},state, {
				slug : { name : action.value }
			});
		case UPDATE_POST_CONTENT:
			return Object.assign({},state, {
				content : action.value
			});
		case UPDATE_POST_EXCERPT:
			return Object.assign({},state, {
				excerpt : action.value
			});
		case ADD_POST_CATEGORY:
			if(typeof state.categories !== 'undefined')
			{
				for (var i = 0; i < state.categories.length; i++) {
					var id = state.categories[i];
					var aId = action.value._id;
					if(id == aId)
					{
						return state;
					}

				};
				
				var categories = state.categories.slice();
				categories.push(action.value._id);
				return Object.assign({},state, {
					categories : categories
				});
			}
			return state;
		case DELETE_POST_CATEGORY:
			if(typeof state.categories !== 'undefined') {
				for (var i = 0; i < state.categories.length; i++) {
					if(state.categories[i] == action.value._id)
					{
						if(i == state.categories.length - 1) {
							return Object.assign({},state,{
								categories : state.categories.slice(0,i)
							});
						} 
						else {
							var firstChunk = state.categories.slice(0,i-1);
							var secondChunk = state.categories.slice(i+1,state.categories.length);
							var finalArray = firstChunk.concat(secondChunk);
							return Object.assign({},state,{
								categories : finalArray
							});
						}

						
						break;
					}
				};
				return state;
			}
			else {
				return state;
			}
			return state;
		case CLEAR_POST:
			return {};
		case UPDATE_POST_CATEGORIES:
			if(typeof action.value !== 'undefined') {
				return Object.assign({},state,{
					categories: action.value
				});
			}
			return state;
		case UPDATE_POST_TAGS:
			if(typeof action.tags !== 'undefined')
			{
				return Object.assign({},state,{
					tags : action.tags
				});
			}
			return state;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/common/reducers/posts.js